export default __webpack_public_path__ + "static/media/Matteo.1b711cec.jpg";